import { render, staticRenderFns } from "./CouponListWindow.vue?vue&type=template&id=71d8c8b6&scoped=true&"
import script from "./CouponListWindow.vue?vue&type=script&lang=js&"
export * from "./CouponListWindow.vue?vue&type=script&lang=js&"
import style0 from "./CouponListWindow.vue?vue&type=style&index=0&id=71d8c8b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d8c8b6",
  null
  
)

export default component.exports